import React from "react";
import { useNavigate } from "react-router-dom";
import BackLink from "./BackLink";

export default function AdUnavailable({ adId, title, text }) {
  const navigate = useNavigate();

  return (
    <>
      <div className="ad-details-backlink">
        <BackLink label="Πίσω" />
      </div>

      <div className="ad-details-container">
        <div className="ad-notfound">
          <div className="ad-notfound-icon">⚠️</div>

          <h1 className="ad-notfound-title">
            {title || "Η αγγελία δεν είναι πλέον διαθέσιμη"}
          </h1>

          <div className="ad-notfound-text">
            {text || "Ίσως διαγράφηκε ή δεν είναι πλέον ενεργή."}
          </div>

          <div className="ad-notfound-actions">
            <button
              className="ad-notfound-btn ad-notfound-btn--primary"
              onClick={() => navigate("/")}
            >
              Στην αρχική
            </button>

            <button
              className="ad-notfound-btn ad-notfound-btn--ghost"
              onClick={() => {
                if (adId) {
                  navigate(`/similar/${adId}`);
                } else {
                  navigate("/");
                }
              }}
            >
              Παρόμοιες αγγελίες
            </button>
          </div>
        </div>
      </div>
    </>
  );
}